<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Empower Your Marketplace with Minglepay's Payment Gateway</div>
            <div class="banner_tips mt-40 fw-300">Transform your marketplace into a seamless, secure, and scalable platform with Minglepay's advanced payment solutions. Focus on growing your listings while we handle fast, reliable, and customer-centric transactions.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Why Minglepay for Marketplaces?</div>
                <div class="title_tag color6">Key Features to Drive Success</div>
            </div>
          <div class="py-20" v-for="item in list1" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center" :class="[item.id%2==0?'order-2':'']">
                    <div class="page_title ">
                        <img src="../../assets/image/btzs.png" alt="" class="h-10px mb-20" >
                        <div class="title_name color3 text-l">{{ item.title }}</div>
                        <div class="title_tag color6 text-l">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Unleash the Power of AI-Powered Analytics</div>
                <div class="title_tag color6">Gain a competitive edge with Minglepay’s advanced analytics tools. Our platform provides:</div>
            </div>
          <div class="py-20" v-for="item in list2" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center" :class="[item.id%2==0?'order-2':'']">
                    <div class="page_title ">
                        <img src="../../assets/image/btzs.png" alt="" class="h-10px mb-20" >
                        <div class="title_name color3 text-l">{{ item.title }}</div>
                        <div class="title_tag color6 text-l">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container bg-6 page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">What is a Payment Gateway?</div>
                <div class="title_tag color1">A payment gateway acts as a secure bridge, seamlessly transferring financial data between customers, sellers, and banks. With Minglepay, every transaction is fast, safe, and optimized for your marketplace’s success.</div>
            </div>
        </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Global Reach with Open Banking</div>
                <div class="title_tag color6">Minglepay is a leading global payment platform and open banking provider. Through secure data-sharing with trusted banks</div>
            </div>
          <div class="py-20" v-for="item in list3" :key="item.id">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center" :class="[item.id%2==0?'order-2':'']">
                    <div class="page_title ">
                        <img src="../../assets/image/btzs.png" alt="" class="h-10px mb-20" >
                        <div class="title_name color3 text-l">{{ item.title }}</div>
                        <div class="title_tag color6 text-l">{{ item.msg }}</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img :src="item.img" alt="">
                  </div>
                </div>
              </div>
          </div>
          <div class="py-20" >
            <div class="page_title pt-30">
                <div class="title_name color2 ">FAQs</div>
                
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_8 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How fast are transactions processed?" name="1">
                            <div class="coll_item">Funds are available in your account within minutes, thanks to our instant transaction technology.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is Minglepay secure for marketplaces?" name="2">
                           <div class="coll_item">Yes, our platform uses advanced encryption and AI-powered fraud detection to ensure every transaction is protected.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I integrate Minglepay with my existing platform?" name="3">
                           <div class="coll_item">Absolutely! Our streamlined APIs make integration quick and easy, getting your marketplace up and running in no time.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t20.png" alt="">
                  </div>
                </div>

            </div>
          </div>
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t32.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Tools to Supercharge Your Marketplace</div>
                        <div class="title_tag color6 text-l">Experience the efficiency of instant payments, seamless integrations, and powerful analytics. With Minglepay, your marketplace can focus on growth while we take care of the payments.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from '../../assets/image/t22.png'
import icon2 from '../../assets/image/t23.png'
import icon3 from '../../assets/image/t24.png'
import icon4 from '../../assets/image/t25.png'

import icon5 from '../../assets/image/t26.png'
import icon6 from '../../assets/image/t27.png'
import icon7 from '../../assets/image/t28.png'

import icon8 from '../../assets/image/t29.png'
import icon9 from '../../assets/image/t30.png'
import icon10 from '../../assets/image/t31.png'
export default {
    data(){
        return{
            list1:[
                {title:'Effortless Pay-Ins and Pay-Outs',msg:'Simplify transactions with streamlined pay-in and pay-out processes, optimized for speed and reliability.',img:icon1,id:1},
                {title:'Intuitive User Experience',msg:'Delight buyers and sellers with a seamless, user-friendly payment interface designed for convenience.',img:icon2,id:2},
                {title:'Smart Payment Routing',msg:'Our AI-driven routing ensures transactions are processed efficiently, minimizing delays and costs.',img:icon3,id:3},
                {title:'Diverse Payment Options',msg:'Offer a wide range of popular payment methods to cater to your customers’ preferences.',img:icon4,id:4},
            ],
            list2:[
                {title:"Customer Behavior Insights",msg:"Understand your users with detailed segmentation and predictive algorithms.",img:icon5,id:1},
                {title:"Real-Time Data",msg:"Monitor transactions and trends to make informed business decisions.",img:icon6,id:2},
                {title:"Actionable Forecasting",msg:"Anticipate market demands with AI-driven forecasting tools.",img:icon7,id:3},
            
            ],
            list3:[
                {title:"Connected Banking Network",msg:"Integrate with major banks across the UK, EU, and beyond for effortless payments.",img:icon8,id:1},
                {title:"AI-Enhanced Solutions",msg:"Leverage machine-learning technology for smarter, more secure transaction processing.",img:icon9,id:2},
                {title:"Scalable Growth Plans",msg:"From small marketplaces to global platforms, our flexible solutions grow with you.",img:icon10,id:3},
            
            ],
            activeName:'1',
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg4.png);
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}


</style>